import z from "zod";

const instanceSchema = z.object({
  uri: z.string().default(""),
  title: z.string().default(""),
  short_description: z.string().default(""),
  description: z.string().default(""),
  email: z.string().default(""),
  version: z.string().default(""),
  urls: z
    .object({
      streaming_api: z.string(),
    })
    .default({ streaming_api: "" }),
  thumbnail: z.string().default(""),
  languages: z.array(z.string()).default([]),
  registrations: z.boolean().default(false),
  approval_required: z.boolean().default(true),
  invites_enabled: z.boolean().default(false),
  configuration: z
    .object({
      statuses: z.object({
        title_max_characters: z.number(),
        max_characters: z.number(),
        max_media_attachments: z.number(),
        characters_reserved_per_url: z.number(),
      }),
      chats: z.object({
        max_characters: z.number(),
        max_messages_per_minute: z.number(),
        max_media_attachments: z.number(),
      }),
      media_attachments: z.object({
        supported_mime_types: z.array(z.string()),
        image_size_limit: z.number(),
        image_matrix_limit: z.number(),
        video_size_limit: z.number(),
        video_frame_rate_limit: z.number(),
        video_matrix_limit: z.number(),
        video_duration_limit: z.number(),
      }),
      polls: z.object({
        max_options: z.number(),
        max_characters_per_option: z.number(),
        min_expiration: z.number(),
        max_expiration: z.number(),
      }),
      ads: z.object({
        algorithm: z.object({
          name: z.string().nullable(),
          configuration: z.object({
            frequency: z.number(),
            phase_min: z.number(),
            phase_max: z.number(),
          }),
        }),
      }),
      groups: z.object({
        max_characters_name: z.number(),
        max_characters_description: z.number(),
        max_admins_allowed: z.number(),
      }),
      tv: z
        .object({
          live_content_carousel: z
            .object({
              preview_seconds: z.number().default(30),
              feed_position: z.number().default(3),
            })
            .default({ preview_seconds: 30, feed_position: 3 }),
        })
        .default({
          live_content_carousel: { preview_seconds: 30, feed_position: 3 },
        }),
    })
    .default({
      statuses: {
        title_max_characters: 0,
        max_characters: 0,
        max_media_attachments: 0,
        characters_reserved_per_url: 0,
      },
      chats: {
        max_characters: 0,
        max_messages_per_minute: 0,
        max_media_attachments: 0,
      },
      media_attachments: {
        supported_mime_types: [],
        image_size_limit: 0,
        image_matrix_limit: 0,
        video_size_limit: 0,
        video_frame_rate_limit: 0,
        video_duration_limit: 0,
        video_matrix_limit: 0,
      },
      polls: {
        max_options: 0,
        max_characters_per_option: 0,
        min_expiration: 0,
        max_expiration: 0,
      },
      ads: {
        algorithm: {
          name: "",
          configuration: { frequency: 0, phase_min: 0, phase_max: 0 },
        },
      },
      groups: {
        max_characters_name: 0,
        max_characters_description: 0,
        max_admins_allowed: 0,
      },
      tv: {
        live_content_carousel: { preview_seconds: 30, feed_position: 3 },
      },
    }),
  feature_quote: z.boolean().default(false),
  rules: z
    .array(
      z.object({
        id: z.string(),
        text: z.string(),
        subtext: z.string(),
        rule_type: z.enum(["account", "content", "group"]),
      }),
    )
    .default([]),
});

type Instance = z.infer<typeof instanceSchema>;

export { instanceSchema, type Instance };
